var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "468-Clipboard Check",
    id: "_468-Clipboard_Check"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "27 11 27 1 23 1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "5 1 1 1 1 31 12 31"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    height: 4,
    width: 12,
    x: 8,
    y: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "23 11 23 4 20 4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "8 4 5 4 5 27 11 27"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 23,
    cy: 23,
    r: 8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "19 24 21 26 27 20"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check_icon.678886dd282c9b0a091bd051ac95eda3.svg";
export { ForwardRef as ReactComponent };